import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "flex flex-wrap gap-4 w-full mb-4" }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-column flex-1"
}
const _hoisted_4 = { class: "flex flex-row w-full justify-content-between info-label-container align-items-center required" }
const _hoisted_5 = { class: "flex align-items-center" }
const _hoisted_6 = { class: "ml-2 text-color-red-dark" }
const _hoisted_7 = { class: "flex align-items-center" }
const _hoisted_8 = { class: "ml-2 text-color-red-dark" }
const _hoisted_9 = { class: "p-error" }
const _hoisted_10 = {
  key: 3,
  class: "flex flex-column flex-1"
}
const _hoisted_11 = { class: "flex flex-row w-full justify-content-between info-label-container align-items-center required" }
const _hoisted_12 = { class: "flex align-items-center" }
const _hoisted_13 = { class: "ml-2 text-color-red-dark" }
const _hoisted_14 = { class: "p-error" }
const _hoisted_15 = { class: "flex flex-wrap gap-4 w-full mb-4" }
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = {
  key: 1,
  class: "flex flex-column"
}
const _hoisted_18 = { class: "flex flex-row w-full justify-content-between info-label-container align-items-center required" }
const _hoisted_19 = { class: "p-error" }
const _hoisted_20 = { class: "flex-1 required" }
const _hoisted_21 = { class: "flex flex-row align-items-center" }
const _hoisted_22 = { class: "flex flex-column" }
const _hoisted_23 = ["textContent"]
const _hoisted_24 = ["textContent"]
const _hoisted_25 = { class: "flex flex-row align-items-center" }
const _hoisted_26 = { class: "flex flex-column" }
const _hoisted_27 = ["textContent"]
const _hoisted_28 = { class: "p-error" }
const _hoisted_29 = { class: "flex flex-wrap gap-4 w-full" }
const _hoisted_30 = { class: "flex-1 required" }
const _hoisted_31 = { class: "p-error" }
const _hoisted_32 = { class: "flex-1 required" }
const _hoisted_33 = { class: "p-error" }
const _hoisted_34 = {
  key: 0,
  class: "flex flex-wrap gap-4 w-full mt-4"
}
const _hoisted_35 = { class: "flex-1 required" }
const _hoisted_36 = { class: "p-error" }
const _hoisted_37 = { class: "flex-1" }
const _hoisted_38 = { class: "field col-12 mt-4 p-0 pr-4 align-content-center" }
const _hoisted_39 = { class: "field col-12 mt-4 p-3 border-round-lg bg-gray-50" }
const _hoisted_40 = { class: "flex flex-wrap gap-4 mt-4 w-full" }
const _hoisted_41 = { class: "flex-1" }
const _hoisted_42 = { class: "flex-1" }

import { computed, inject, onMounted, ref, Ref, toRefs } from 'vue';
import InputNumber from 'primevue/inputnumber';
import MultiSelect from 'primevue/multiselect';
import Message from 'primevue/message';
import useVuelidate from '@vuelidate/core';
import { required, requiredIf, helpers, url } from '@vuelidate/validators';

import OrganizationContractGroupEvents from './OrganizationContractGroupEvents.vue';
import OrganizationContractNoShow from './OrganizationContractNoShow.vue';
import { useOrganizationContractsStore, useTherapyStore } from '@/store';
import { ContractDetailInterface, DropdownOptionInterface, GroupEventInterface } from '@/types';
import { useDateTime } from '@/composables';
import { CONTRACT_ENUMS } from '@/enum';
import OrganizationContractEvaluations from './OrganizationContractEvaluations.vue';

interface Props {
  contract: ContractDetailInterface;
  loading: boolean;
  scope: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationContractMainForm',
  props: {
    contract: {},
    loading: { type: Boolean },
    scope: {}
  },
  setup(__props: any) {

const contractStore = useOrganizationContractsStore();
const therapyStore = useTherapyStore();

const props = __props;
const { contract, loading, scope } = toRefs(props);
const canEdit = contractStore.canEditOrCreateContracts;
const caseloadManagementTypes = ref<DropdownOptionInterface[]>();
const eventsRemovedByDateEdit = ref<number>(0);
const eventsRemovedForNewContract = ref<number>(0);
const openServiceDateNotice = ref<boolean>(false);
const caseloadsLoading = ref<boolean>(false);
const selectedMainForm = inject<Ref<CONTRACT_ENUMS.FORMS>>('selectedForm', ref(CONTRACT_ENUMS.FORMS.FLAT_FEE));
const originalPaymentStartDate = ref<Date>();
const originalPaymentEndDate = ref<Date>();

const toolTipText = {
  contract: 'Date range in which service providers can deliver services.',
  service: 'Date range in which service providers can schedule and document events.',
  payment: 'Date range in which invoices will be issued.',
};

onMounted(() => {
  contractStore.getSalesReps();
  cleanSalerep();
  getCaseloadManagementTypes();
});

const cleanSalerep = () => {
  const salesrep = contract.value.salesrep;
  const editType = contractStore.editType;
  const resetEditTypes = [CONTRACT_ENUMS.CONTRACT_EDIT_TYPES.EDIT];

  if (!salesrep?.active && !resetEditTypes.includes(editType)) {
    contract.value.salesrep = undefined;
  }
};

const handleContractDateChange = async (val: Date[]) => {
  contract.value.start_at = useDateTime().formatDateForApi(val[0]);
  contract.value.end_at = useDateTime().formatDateForApi(val[1]);
  eventsRemovedByDateEdit.value = 0;
  eventsRemovedForNewContract.value = 0;
  if (contractStore.editType === CONTRACT_ENUMS.CONTRACT_EDIT_TYPES.EDIT) {
    const response = await contractStore.checkEventToRemove();
    eventsRemovedByDateEdit.value = response.events_count;
  } else {
    const serviceStartDate = useDateTime().formatDateForApi(val[0]);
    const response = await contractStore.getEventsRemovedForNewContract(serviceStartDate);
    eventsRemovedForNewContract.value = response.events_count;
  }
};

const handleContractServiceDateChange = (val: Date[]) => {
  contract.value.service_start_at = useDateTime().formatDateForApi(val[0]);
  contract.value.service_end_at = useDateTime().formatDateForApi(val[1]);
  openServiceDateNotice.value = false;
  if (contractStore.editType === CONTRACT_ENUMS.CONTRACT_EDIT_TYPES.EDIT) {
    openServiceDateNotice.value = true;
  }
};

const handleContractPaymentDateChange = (val: Date[]) => {
  if (!originalPaymentStartDate.value) originalPaymentStartDate.value = new Date(contract.value.payment_start_at);
  if (!originalPaymentEndDate.value) originalPaymentEndDate.value = new Date(contract.value.payment_end_at);
  contract.value.payment_start_at = useDateTime().formatDateForApi(val[0]);
  contract.value.payment_end_at = useDateTime().formatDateForApi(val[1]);
};

const contractDates = computed(() => {
  if (contract.value.start_at) {
    return [new Date(contract.value.start_at + ' 00:00:00'), new Date(contract.value.end_at + ' 00:00:00')];
  }
  return ['', ''];
});

const paymentDates = computed(() => {
  if (contract.value.payment_start_at) {
    return [
      new Date(contract.value.payment_start_at + ' 00:00:00'),
      new Date(contract.value.payment_end_at + ' 00:00:00'),
    ];
  }
  return ['', ''];
});

const serviceDates = computed(() => {
  if (contract.value.service_start_at && contract.value.service_end_at)
    return [
      new Date(contract.value.service_start_at + ' 00:00:00'),
      new Date(contract.value.service_end_at + ' 00:00:00'),
    ];
  return ['', ''];
});

const endDateLessThanStartDate =
  (startPointer: 'start_at' | 'service_start_at' | 'payment_start_at') => (value: string) => {
    const until = new Date(value as string);
    const start = new Date((contract.value[startPointer] as string) + ' 00:00:00');
    const untilLaterThanStart = until.valueOf() > start.valueOf();

    return untilLaterThanStart;
  };

const serviceDateStartThirtyDayCheck = (value: string) => {
  const serviceStart = new Date((value as string) + ' 00:00:00');
  const contractStart = new Date((contract.value.start_at as string) + ' 00:00:00');
  return (
    serviceStart.valueOf() <= contractStart.valueOf() &&
    useDateTime().getNumberOfDaysBetweenTwoDates(serviceStart, contractStart) <= 30
  );
};

const serviceDateEndThirtyDayCheck = (value: string) => {
  const serviceEnd = new Date((value as string) + ' 00:00:00');
  const contractEnd = new Date((contract.value.end_at as string) + ' 00:00:00');
  return (
    serviceEnd.valueOf() >= contractEnd.valueOf() &&
    useDateTime().getNumberOfDaysBetweenTwoDates(serviceEnd, contractEnd) <= 30
  );
};

const rules = computed(() => {
  return {
    start_at: {
      required: helpers.withMessage('Please select a contract start date', required),
    },
    end_at: {
      required: helpers.withMessage('Please select a contract end date', required),
      endDateLessThanStartDate: helpers.withMessage(
        'Please choose a date greater than or equal to the contact start date',
        endDateLessThanStartDate('start_at'),
      ),
    },
    service_start_at: {
      required: helpers.withMessage('Please select a service start date', required),
      isNotThirtyDaysBeforeContractStart: helpers.withMessage(
        'Service start date must be between 0 and 30 days before contract start date',
        serviceDateStartThirtyDayCheck,
      ),
    },
    service_end_at: {
      required: helpers.withMessage('Please select a service end date', required),
      endDateLessThanStartDate: helpers.withMessage(
        'Please choose a date greater than or equal to the service start date',
        endDateLessThanStartDate('service_start_at'),
      ),
      isNotThirtyDaysAfterContractStart: helpers.withMessage(
        'Service end date must be between 0 and 30 days after contract end date',
        serviceDateEndThirtyDayCheck,
      ),
    },
    payment_start_at: {
      required: helpers.withMessage('Please select a payment start date', required),
    },
    payment_end_at: {
      required: helpers.withMessage('Please select a payment end date', required),
      endDateLessThanStartDate: helpers.withMessage(
        'Please choose a date greater than or equal to the payment start date',
        endDateLessThanStartDate('payment_start_at'),
      ),
    },
    contract_identifier: {
      required: helpers.withMessage('Please provide a contract identifier', required),
      url: helpers.withMessage('Must be a valid URL starting with https(s)://', url),
    },
    salesrep: {
      required: helpers.withMessage('Please select a sales rep', required),
    },
    quote_number: {
      required: helpers.withMessage('Please provide a quote number', required),
    },
    hours_contracted: {
      requiredIfCustom: helpers.withMessage(
        'Please provide total contracted hours',
        requiredIf(selectedMainForm.value === CONTRACT_ENUMS.FORMS.HOURLY),
      ),
    },
  };
});

const v$ = useVuelidate(rules, contract, { $scope: scope.value });

const getCaseloadManagementTypes = async () => {
  caseloadsLoading.value = true;
  const caseloadTypesResponse = await therapyStore.getCaseloadManagementTypes();
  caseloadManagementTypes.value = caseloadTypesResponse.map(({ id, name }) => {
    return {
      name,
      value: id,
    };
  });
  caseloadsLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_AppDateRangePicker = _resolveComponent("AppDateRangePicker")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(loading))
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 0,
            height: "2.3rem"
          }))
        : _createCommentVNode("", true),
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { for: "service_dates" }, "Contract Date Range", -1)),
              _withDirectives(_createVNode(_component_Icon, {
                name: "info",
                class: "text-gray-400 text-base"
              }, null, 512), [
                [
                  _directive_tooltip,
                  toolTipText.contract,
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _createVNode(_component_AppDateRangePicker, {
              id: "contract_dates",
              value: contractDates.value,
              class: _normalizeClass(["org-datepicker", {
            'p-invalid': (_unref(v$).start_at.$invalid && _unref(v$).start_at.$dirty) || (_unref(v$).end_at.$invalid && _unref(v$).end_at.$dirty),
          }]),
              disabled: !_unref(canEdit),
              onChange: handleContractDateChange,
              onBlur: _cache[0] || (_cache[0] = 
            () => {
              _unref(v$).start_at.$touch();
              _unref(v$).end_at.$touch();
            }
          )
            }, null, 8, ["value", "class", "disabled"]),
            (eventsRemovedByDateEdit.value)
              ? (_openBlock(), _createBlock(_unref(Message), {
                  key: 0,
                  closable: false,
                  class: "contract-date-notice border-primary w-full justify-content-start my-1",
                  severity: "warn",
                  icon: "none"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_Icon, {
                        name: "warning",
                        class: "confirm-dialog-icon text-color-yellow-dark text-lg align-self-start"
                      }),
                      _createElementVNode("p", _hoisted_6, [
                        _cache[14] || (_cache[14] = _createTextVNode(" Changing the contract date range will remove ", -1)),
                        _createElementVNode("b", null, _toDisplayString(eventsRemovedByDateEdit.value), 1),
                        _cache[15] || (_cache[15] = _createTextVNode(" scheduled events outside of ", -1)),
                        _createElementVNode("b", null, _toDisplayString(_unref(useDateTime)().formatIntlDate(_unref(contract).start_at)) + " - " + _toDisplayString(_unref(useDateTime)().formatIntlDate(_unref(contract).end_at)), 1),
                        _cache[16] || (_cache[16] = _createTextVNode(" . ", -1))
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (eventsRemovedForNewContract.value)
              ? (_openBlock(), _createBlock(_unref(Message), {
                  key: 1,
                  closable: false,
                  class: "contract-date-notice border-primary w-full justify-content-start my-1",
                  severity: "warn",
                  icon: "none"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_Icon, {
                        name: "warning",
                        class: "confirm-dialog-icon text-color-yellow-dark text-lg align-self-start"
                      }),
                      _createElementVNode("p", _hoisted_8, [
                        _cache[17] || (_cache[17] = _createTextVNode(" Adding this contract will remove ", -1)),
                        _createElementVNode("b", null, _toDisplayString(eventsRemovedForNewContract.value), 1),
                        _cache[18] || (_cache[18] = _createTextVNode(" scheduled events after ", -1)),
                        _createElementVNode("b", null, _toDisplayString(_unref(useDateTime)().formatIntlDate(_unref(contract).start_at)), 1),
                        _cache[19] || (_cache[19] = _createTextVNode(" . ", -1))
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._unref(v$).start_at.$errors, ..._unref(v$).end_at.$errors], (error) => {
              return (_openBlock(), _createElementBlock("div", {
                key: error.$uid,
                class: "input-errors mt-1"
              }, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_unref(loading))
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 2,
            height: "2.3rem"
          }))
        : _createCommentVNode("", true),
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { for: "service_dates" }, "Service Date Range", -1)),
              _withDirectives(_createVNode(_component_Icon, {
                name: "info",
                class: "text-gray-400 text-base"
              }, null, 512), [
                [
                  _directive_tooltip,
                  toolTipText.service,
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _createVNode(_component_AppDateRangePicker, {
              id: "service_dates",
              value: serviceDates.value,
              class: _normalizeClass(["org-datepicker", {
            'p-invalid':
              (_unref(v$).service_start_at.$invalid && _unref(v$).service_start_at.$dirty) ||
              (_unref(v$).service_end_at.$invalid && _unref(v$).service_end_at.$dirty),
          }]),
              disabled: !_unref(canEdit),
              onChange: handleContractServiceDateChange,
              onBlur: _cache[1] || (_cache[1] = 
            () => {
              _unref(v$).service_start_at.$touch();
              _unref(v$).service_end_at.$touch();
            }
          )
            }, null, 8, ["value", "class", "disabled"]),
            (openServiceDateNotice.value)
              ? (_openBlock(), _createBlock(_unref(Message), {
                  key: 0,
                  closable: false,
                  class: "contract-date-notice border-primary w-full justify-content-start my-1",
                  severity: "warn",
                  icon: "none"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Icon, {
                        name: "warning",
                        class: "confirm-dialog-icon text-color-yellow-dark text-lg align-self-start"
                      }),
                      _createElementVNode("p", _hoisted_13, [
                        _cache[21] || (_cache[21] = _createTextVNode(" Service Providers will only be able to create and document events between ", -1)),
                        _createElementVNode("b", null, _toDisplayString(_unref(useDateTime)().formatIntlDate(_unref(contract).service_start_at)) + " - " + _toDisplayString(_unref(useDateTime)().formatIntlDate(_unref(contract).service_end_at)), 1),
                        _cache[22] || (_cache[22] = _createTextVNode(" . ", -1))
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._unref(v$).service_start_at.$errors, ..._unref(v$).service_end_at.$errors], (error) => {
              return (_openBlock(), _createElementBlock("div", {
                key: error.$uid,
                class: "input-errors mt-1"
              }, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        (_unref(loading))
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              height: "2.3rem"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { for: "end" }, "Payment Date Range", -1)),
                _withDirectives(_createVNode(_component_Icon, {
                  name: "info",
                  class: "text-gray-400 text-base"
                }, null, 512), [
                  [
                    _directive_tooltip,
                    toolTipText.payment,
                    void 0,
                    { top: true }
                  ]
                ])
              ]),
              _createVNode(_component_AppDateRangePicker, {
                id: "payment_date_range",
                value: paymentDates.value,
                class: _normalizeClass(["org-datepicker", {
              'p-invalid':
                (_unref(v$).payment_start_at.$invalid && _unref(v$).payment_start_at.$dirty) ||
                (_unref(v$).payment_end_at.$invalid && _unref(v$).payment_end_at.$dirty),
            }]),
                disabled: !_unref(canEdit),
                onChange: handleContractPaymentDateChange,
                onBlur: _cache[2] || (_cache[2] = 
              () => {
                _unref(v$).payment_start_at.$touch();
                _unref(v$).payment_end_at.$touch();
              }
            )
              }, null, 8, ["value", "class", "disabled"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._unref(v$).payment_start_at.$errors, ..._unref(v$).payment_end_at.$errors], (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: error.$uid,
                  class: "input-errors mt-1"
                }, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ]))
      ]),
      _createElementVNode("div", _hoisted_20, [
        _cache[24] || (_cache[24] = _createElementVNode("label", { for: "sales_rep" }, "Sales Rep", -1)),
        (_unref(loading))
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              height: "2.3rem"
            }))
          : (_openBlock(), _createBlock(_component_Dropdown, {
              key: 1,
              id: "sales_rep",
              modelValue: _unref(contract).salesrep,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(contract).salesrep) = $event)),
              class: _normalizeClass(["w-full mt-2", {
            'p-invalid': _unref(v$).salesrep.$invalid && _unref(v$).salesrep.$dirty,
          }]),
              style: _normalizeStyle({
            backgroundColor: !_unref(contract).salesrep?.active ? '#F3F5F5' : '',
          }),
              options: _unref(contractStore).salesReps,
              "option-label": "display_name",
              placeholder: "Select Sales Rep",
              disabled: !_unref(canEdit),
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_unref(v$).salesrep.$touch()))
            }, {
              value: _withCtx((value) => [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    (value.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "font-bold",
                          textContent: _toDisplayString(value.value.display_name)
                        }, null, 8, _hoisted_23))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          textContent: _toDisplayString(value.placeholder)
                        }, null, 8, _hoisted_24))
                  ])
                ])
              ]),
              option: _withCtx((option) => [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", {
                      textContent: _toDisplayString(option.option.display_name)
                    }, null, 8, _hoisted_27)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "class", "style", "options", "disabled"])),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).salesrep.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            key: error.$uid,
            class: "input-errors mt-1"
          }, [
            _createElementVNode("div", _hoisted_28, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _cache[25] || (_cache[25] = _createElementVNode("label", { for: "quote" }, "Quote Number", -1)),
        (_unref(loading))
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              height: "2.3rem"
            }))
          : (_openBlock(), _createBlock(_component_InputText, {
              key: 1,
              id: "quote",
              modelValue: _unref(contract).quote_number,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(contract).quote_number) = $event)),
              placeholder: "e.g. 123456",
              class: _normalizeClass(["data w-full mt-2", { 'p-invalid': _unref(v$).quote_number.$invalid && _unref(v$).quote_number.$dirty }]),
              disabled: !_unref(canEdit),
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_unref(v$).quote_number.$touch()))
            }, null, 8, ["modelValue", "class", "disabled"])),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).quote_number.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            key: error.$uid,
            class: "input-errors mt-1"
          }, [
            _createElementVNode("div", _hoisted_31, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_32, [
        _cache[26] || (_cache[26] = _createElementVNode("label", { for: "id" }, "Contract Identifier", -1)),
        (_unref(loading))
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              height: "2.3rem"
            }))
          : (_openBlock(), _createBlock(_component_InputText, {
              key: 1,
              id: "id",
              modelValue: _unref(contract).contract_identifier,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(contract).contract_identifier) = $event)),
              placeholder: "Contract Identifier",
              class: _normalizeClass(["data w-full mt-2", { 'p-invalid': _unref(v$).contract_identifier.$invalid && _unref(v$).contract_identifier.$dirty }]),
              disabled: !_unref(canEdit),
              onBlur: _cache[8] || (_cache[8] = ($event: any) => (_unref(v$).contract_identifier.$touch()))
            }, null, 8, ["modelValue", "class", "disabled"])),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).contract_identifier.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            key: error.$uid,
            class: "input-errors mt-1"
          }, [
            _createElementVNode("div", _hoisted_33, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ])
    ]),
    (_unref(selectedMainForm) === _unref(CONTRACT_ENUMS).FORMS.HOURLY)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[27] || (_cache[27] = _createElementVNode("label", { for: "hours" }, "Hours Contracted", -1)),
            (_unref(loading))
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 0,
                  height: "2.3rem"
                }))
              : (_openBlock(), _createBlock(_unref(InputNumber), {
                  key: 1,
                  id: "hours",
                  modelValue: _unref(contract).hours_contracted,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(contract).hours_contracted) = $event)),
                  mode: "decimal",
                  "max-fraction-digits": 2,
                  "min-fraction-digits": 0,
                  placeholder: "Hours Contracted",
                  class: _normalizeClass(["w-full data mt-2", { 'p-invalid': _unref(v$).hours_contracted.$invalid && _unref(v$).hours_contracted.$dirty }]),
                  disabled: !_unref(canEdit),
                  onBlur: _cache[10] || (_cache[10] = ($event: any) => (_unref(v$).hours_contracted.$touch()))
                }, null, 8, ["modelValue", "class", "disabled"])),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).hours_contracted.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                key: error.$uid,
                class: "input-errors mt-1"
              }, [
                _createElementVNode("div", _hoisted_36, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_37, [
            _cache[28] || (_cache[28] = _createElementVNode("label", { for: "caseloads" }, "Caseload Management Type", -1)),
            (caseloadsLoading.value)
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 0,
                  height: "2.3rem"
                }))
              : (_openBlock(), _createBlock(_unref(MultiSelect), {
                  key: 1,
                  id: "caseloads",
                  modelValue: _unref(contract).caseloads,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(contract).caseloads) = $event)),
                  class: "w-full mt-2",
                  options: caseloadManagementTypes.value,
                  "option-label": "name",
                  placeholder: "Select Caseload Management Type(s)",
                  disabled: !_unref(canEdit)
                }, null, 8, ["modelValue", "options", "disabled"]))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_38, [
      (_unref(loading))
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 0,
            height: "2.3rem"
          }))
        : (_openBlock(), _createBlock(_component_Checkbox, {
            key: 1,
            id: "split-caseload",
            modelValue: _unref(contract).split_caseload,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(contract).split_caseload) = $event)),
            "true-value": 1,
            "false-value": 0,
            binary: true,
            class: "mr-2",
            disabled: !_unref(canEdit)
          }, null, 8, ["modelValue", "disabled"])),
      _cache[29] || (_cache[29] = _createElementVNode("label", {
        class: "mb-0 font-bold",
        for: "split-caseload"
      }, "Split Caseload Management", -1))
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createVNode(OrganizationContractEvaluations, { scope: _unref(scope) }, null, 8, ["scope"])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createVNode(OrganizationContractNoShow, {
          class: "flex-1",
          contract: _unref(contract),
          scope: _unref(scope)
        }, null, 8, ["contract", "scope"])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createVNode(OrganizationContractGroupEvents, {
          loading: _unref(loading),
          groups: (_unref(contract).groups as GroupEventInterface[]),
          scope: _unref(scope)
        }, null, 8, ["loading", "groups", "scope"])
      ])
    ])
  ]))
}
}

})